module.exports = __webpack_public_path__ + "img/IMG-20200405-WA0012.37574af5.jpg";